<template>
  <div>
    <!-- 顶部导航 -->
    <HeaderTemplate v-if="!isAdminRoute"></HeaderTemplate>

    <!-- 路由组件展示区：根据 URL 变化，这里的内容会动态替换 -->
    <main>
      <router-view></router-view>
    </main>
    <FooterTemplate v-if="!isAdminRoute"></FooterTemplate>
  </div>
</template>

<script>

import HeaderTemplate from './components/template/HeaderTemplate.vue'
import FooterTemplate from './components/template/FooterTemplate.vue'


export default {
  name: 'App',
  components: {
    HeaderTemplate,
    FooterTemplate
  },
  computed: {
    isAdminRoute() {
      // 如果使用了 vue-router，这里可以获取到当前路径
      if (!this.$route) return false;

      const path = this.$route.path;
      // 只要路径是以 /admin 开头，或者是登录页 /login，就隐藏前台 Header 和 Footer
      return path.startsWith('/admin');
    }
  }
}

</script>

<style>
body {
  margin: 0 auto;
}

#app {
  font-family: "MiSans", "PingFang SC", "Noto", "roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
